import { render, staticRenderFns } from "./addReformPrototype.vue?vue&type=template&id=7e09e272"
import script from "./addReformPrototype.vue?vue&type=script&lang=js"
export * from "./addReformPrototype.vue?vue&type=script&lang=js"
import style0 from "./addReformPrototype.vue?vue&type=style&index=0&id=7e09e272&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports